import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, first, map } from 'rxjs/operators';
import {
    ICheckoutSingleItemResponse,
    IInsertProcessActionResponse,
    IProcessAction,
    IProcessInstanceCheckoutRequest,
    IProcessInstanceListRequest,
    IProcessView,
    IViewStatusRequest,
    IViewStatusResponse,
    ProcessManagerPageResult,
} from 'src/app/models/process-manager';

import { ConfigurationService, ForceBaseUrl } from '../configuration/configuration.service';
import { EndpointFactory } from '../endpoint-factory.service';

@Injectable({
    providedIn: 'root'
})
export class ProcessManagerEndpoint extends EndpointFactory {

    getServiceBaseUrl(force?: ForceBaseUrl) {
        return this.getBaseUrl('processManager', force) + 'processManager';
    }


    constructor(public http: HttpClient, configurations: ConfigurationService, injector: Injector) {
        super(http, configurations, injector);
    }

    getProcessViews(currentRole: string): Observable<IProcessView[]> {

        const endpointUrl = `${this.getServiceBaseUrl()}/${currentRole}/processview`;

        return this.http.get<IProcessView[]>(endpointUrl).pipe(
            catchError(error => {
                return this.handleError(error);
            })
        );
    }

    getProcessView(displayName, currentRole: string): Promise<IProcessView> {

        const endpointUrl = `${this.getServiceBaseUrl()}/${currentRole}/processview/${displayName}`;

        return this.http.get<IProcessView>(endpointUrl).pipe(
            catchError(error => {
                return this.handleError(error);
            })
        ).toPromise();
    }

    insertAction(req: IProcessAction): Observable<IInsertProcessActionResponse> {

        const endpointUrl = `${this.getServiceBaseUrl()}/action`;

        return this.http.post<IInsertProcessActionResponse>(endpointUrl, req).pipe(
            catchError(error => {
                return this.handleError(error);
            })
        );
    }


    async getViewStatus(processViewId: number, metaData: any) {
        const endpointUrl = `${this.getServiceBaseUrl()}/viewstatus`;
        return await this.http.post<IViewStatusResponse>(endpointUrl, { processViewId, metaData } as IViewStatusRequest).pipe(
            catchError(error => {
                return this.handleError(error);
            })).toPromise();
    }

    getPage(query: IProcessInstanceListRequest): Observable<ProcessManagerPageResult> {
        const endpointUrl = `${this.getServiceBaseUrl()}/processinstance`;

        return this.http.post<ProcessManagerPageResult>(endpointUrl, query).pipe(catchError(error => {
            return this.handleError(error);
        }), map(res => new ProcessManagerPageResult(res)));
    }

    async checkoutNext(query: IProcessInstanceCheckoutRequest): Promise<ICheckoutSingleItemResponse> {
        const endpointUrl = `${this.getServiceBaseUrl()}/checkoutNext`;

        return await this.http.post<ICheckoutSingleItemResponse>(endpointUrl, query).pipe(catchError(error => {
            return this.handleError(error);
        }), first()).toPromise();
    }



}
